import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AuthGuardService implements CanActivate {

    constructor(private _auth: AuthService, private _router: Router) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot){
        const resp = <boolean> await this._auth.isLogin().then((isLogin) => isLogin);
        if ( !resp ) {
            this._router.navigate(['/auth/login']);
        }
        return resp;
    }
 


}


// WEBPACK FOOTER //
// ./src/app/core/guards/auth-guard.service.ts